.popover {
	display: flex;
	flex-direction: column;
	min-height: 0;
	padding: var(--size-4);
	gap: var(--size-4);
	width: 18rem;

	.switcher {
		background-color: rgb(from var(--color-background) r g b / 100%);
		gap: 2px;
		padding: 2px;
		border-radius: calc(var(--radius-md) + 2px);
		overflow: clip;
		display: flex;

		> button {
			flex: 1;
			text-align: center;
			padding: var(--size-2) var(--size-4);
			font-size: var(--text-caption);
			font-weight: 500;
			color: var(--color-text-subtle);
			border-radius: var(--radius-md);
			transition:
				color 0.15s ease,
				background-color 0.15s ease;

			&:hover:not(:disabled):not(&[data-active]) {
				color: var(--active-text, var(--color-text));
				background-color: rgb(from var(--color-surface) r g b / 50%);
			}

			&[data-active] {
				color: var(--active-text);
				background-color: var(--color-surface);
				font-weight: 600;
			}

			&:disabled {
				text-decoration: line-through;
				opacity: 0.5;
			}

			&:focus-visible {
				outline: 2px solid var(--color-border-focus);
				outline-offset: -2px;
			}
		}
	}

	.location {
		display: flex;
		align-items: center;
		gap: var(--size-3);
		font-weight: 600;
		width: 100%;

		.text {
			flex: 1;
			min-width: 0;
		}

		> svg {
			color: var(--color-text-subtle);
			padding: 2px;
		}
	}
}
